import { render, staticRenderFns } from "./AirtimeReport.vue?vue&type=template&id=1880fe48&scoped=true&"
import script from "./AirtimeReport.vue?vue&type=script&lang=js&"
export * from "./AirtimeReport.vue?vue&type=script&lang=js&"
import style0 from "./AirtimeReport.vue?vue&type=style&index=0&id=1880fe48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880fe48",
  null
  
)

export default component.exports